import React from 'react';
import Navbar from '@uniiverse/library/components/navbar';
import { Grid, Loader } from 'semantic-ui-react';
import { injectIntl } from 'react-intl';
import { useQuery } from '@apollo/react-hooks';
import { formatAmount } from 'lib/currencies';
import { ErrorPage } from 'components/utility/ErrorPage';
import BalanceCard from './components/BalanceCard';
import LinkCard from './components/LinkCard';
import styles from './Balance.css';
import Chargebacks from './components/Chargebacks';
import RequestedFunds from './components/RequestedFunds';
import locale from './locale';
import balanceQuery from './balance.gql';

const Balance = injectIntl(({ intl: { formatMessage }, intl, currency, user }) => {
  const { data, loading, error } = useQuery(balanceQuery, {
    variables: { id: user.id },
  });

  if (loading) return <Loader active />;
  if (error) return <ErrorPage />;

  const {accountBalance, unreadMessagesCount} = data.host

  const {
    total_balance: totalBalance = 0,
    upcoming_funds: upcomingFunds = 0,
    withdrawable_balance: withdrawableFunds = 0,
  } = accountBalance.nodes.find(obj => obj.currency === currency) || []

  return (
    <>
      <Navbar user={user} sticky={false} />
      <div className={styles.balanceContainer}>
        <div className={styles.breadcrumb}>
          <a href="/dashboard">
            <span>‹</span>
            <span>{formatMessage(locale.dashboard)}</span>
          </a>
        </div>
        <div className={styles.heading}>
          <h1>{formatMessage(locale.myBalances, { currency })}</h1>
          <p className={styles.subText1}>{formatMessage(locale.subText1)}</p>
          <p>{formatMessage(locale.subText2)}</p>
        </div>

        <Grid columns={3} stackable>
          <Grid.Row>
            <Grid.Column>
              <BalanceCard
                header={formatMessage(locale.totalBalance)}
                formattedAmount={formatAmount(intl, withdrawableFunds, currency)}
                withdrawalButtonText={withdrawableFunds > 0 ? formatMessage(locale.requestFunds) : ''}
                currency={currency}
                tooltip={formatMessage(locale.totalBalanceTooltip, {currency})}
              />
            </Grid.Column>
            <Grid.Column>
              <BalanceCard
                header={formatMessage(locale.upcomingFunds)}
                formattedAmount={formatAmount(intl, upcomingFunds, currency)}
                tooltip={formatMessage(locale.upcomingFundsTooltip)}
              />
            </Grid.Column>
            <Grid.Column>
              <BalanceCard
                header={formatMessage(locale.balances)}
                formattedAmount={formatAmount(intl, totalBalance, currency)}
                tooltip={formatMessage(locale.balancesTooltip)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={8}>
              <RequestedFunds user={user} currency={currency} fluid />
            </Grid.Column>
            <Grid.Column>
              <LinkCard header={formatMessage(locale.quickLinks)} unreadMessagesCount={unreadMessagesCount} />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid stackable>
          <Grid.Row>
            <Grid.Column>
              <Chargebacks user={user} currency={currency} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </>
  );
});

export default Balance;
